import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock, Truck } from "lucide-react";
import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import { popularCountries } from "../mock";

export default function CountriesPage() {
  return (
    <>
      <Seo
        title="Medicine Courier Charges by Country | India to 220+ Countries | ShipMeds"
        description="Explore ShipMeds medicine courier charges and delivery timelines from India to USA, UK, Canada, Australia, UAE, Germany and 220+ countries. Free doorstep pickup."
        path="/countries"
      />
      <PageHero title="Popular Countries" subtitle="We deliver medicines from India to 220+ countries. Explore charges & delivery timelines for popular destinations." crumb="Popular Countries" />
      <section className="py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {popularCountries.map((c) => (
              <Link key={c.slug} to={`/country/${c.slug}`} className="group bg-white rounded-2xl border border-slate-100 card-shadow overflow-hidden hover:-translate-y-1 transition-transform">
                <div className="p-6">
                  <div className="flex items-center gap-4 mb-4">
                    <img src={`https://flagcdn.com/w160/${c.code}.png`} alt={c.name} className="w-14 h-10 object-cover rounded-md shadow-sm" />
                    <h3 className="font-bold text-slate-900 group-hover:text-teal-600 transition-colors">India to {c.name}</h3>
                  </div>
                  <div className="flex items-center justify-between text-sm">
                    <span className="flex items-center gap-1.5 text-slate-500"><Clock className="w-4 h-4 text-teal-500" />{c.days} days</span>
                    <span className="font-bold text-teal-700">from ₹{c.price.toLocaleString()}</span>
                  </div>
                </div>
                <div className="px-6 py-3 bg-slate-50 border-t border-slate-100 flex items-center justify-between text-sm font-semibold text-teal-600">
                  View Charges <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
